// TODO типизировать
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {
  finalize,
  first,
  from,
  map,
  Observable,
  Subject,
  tap,
  throwError,
} from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isTokenRefreshing = false;

  private isLoggingOut = false;

  private readonly tokenRefreshedSource$: Subject<void> = new Subject<void>();

  private readonly tokenRefreshed$: Observable<void> =
    this.tokenRefreshedSource$.asObservable();

  private readonly redirectIgnoreUrls: string[] = [''];

  constructor(private readonly oauthService: OAuthService) {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(this.updateRequestHeader(request)).pipe(
      catchError((error) => {
        // Unauthorized
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // Refresh token
          return this.refreshToken(request).pipe(
            // Set an actual access token
            switchMap(() => next.handle(this.updateRequestHeader(request))),
            tap(() => (this.isLoggingOut = false)),
            catchError((error) => {
              this.logOut();
              return throwError(() => error);
            }),
          );
        }

        // Access to the requested resource is forbidden
        if (
          error instanceof HttpErrorResponse &&
          error.status === 403 &&
          !this.isLoggingOut
        ) {
          this.logOut();
        }

        return throwError(() => error);
      }),
    );
  }

  private updateRequestHeader(request: HttpRequest<any>): HttpRequest<any> {
    const token = this.oauthService.getAccessToken();

    if (token) {
      const headers = request.headers.set(
        'Authorization',
        this.oauthService.authorizationHeader(),
      );
      request = request.clone({ headers });
    }

    return request;
  }

  private refreshToken(request: HttpRequest<any>): Observable<void> {
    if (this.isTokenRefreshing) {
      return this.getRefreshNotifier$();
    }

    this.isTokenRefreshing = true;

    return from(this.oauthService.refreshToken()).pipe(
      map(() => void 0),
      tap(() => this.tokenRefreshedSource$.next()),
      finalize(() => (this.isTokenRefreshing = false)),
      catchError((err) =>
        from(this.handleRefreshTokenError(request)).pipe(
          switchMap(() => throwError(() => err)),
        ),
      ),
    );
  }

  private async handleRefreshTokenError(
    request: HttpRequest<any>,
  ): Promise<void> {
    const shouldIgnoreRedirect = this.redirectIgnoreUrls.some((url) =>
      request.url.includes(url),
    );

    if (shouldIgnoreRedirect) {
      return;
    }

    await this.oauthService.loadDiscoveryDocumentAndLogin();
  }

  private getRefreshNotifier$(): Observable<void> {
    return this.tokenRefreshed$.pipe(first());
  }

  private logOut(): void {
    this.isLoggingOut = true;
    this.oauthService.logOut();
  }
}
